const apiUrl = "https://upcloud.net.br:14001/api"
// const apiUrl = "http://localhost:14001/api"

export default apiUrl